import { LoadPageAction } from '../../../pillar/common/actions/LoadPageAction';
import { LoadPagePayloadWithCustomParams } from './LoadPagePayloadWithCustomParams'

export function getConceptListType<TModel>(module: string, type: { new(): TModel; }): string {
  return `[${module}] Get Selection ${(type as any).$typeName}`;
}

export class GetConceptListAction<TModel> implements LoadPageAction {
  readonly identifier = new Date().getTime().toString();
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }, public payload: LoadPagePayloadWithCustomParams) {
    this.type = getConceptListType(module, modelType );
  }
}





// WEBPACK FOOTER //
// ./src/app/vocabulary/store/actions/GetConceptListAction.ts